import { useTranslation } from 'react-i18next';
import REDSection from '../components/red/REDSection';
import { BusinessRegistrationForm } from './BusinessRegistrationForm';

export const HomePage: React.FC = () => {
  const { t } = useTranslation('pages');

  return (
    <div className='max-w-[752px] mx-auto'>
      <REDSection spacing='none' className='px-6 max-sm:px-4 mt-6'>
        <h1 className="text-3xl font-bold mb-4">{t('home.title')}</h1>
        <p className="mb-8">{t('home.subtitle')}</p>
      </REDSection>
      
      {/* Business Registration Form */}
      <BusinessRegistrationForm />
    </div>
  );
};